import React from 'react';
import { useTranslation } from 'react-i18next';
import useOwnerResource from '../../hooks/useOwnerResource';

interface RenderUserProps {
    item: any
    subtitle?: boolean
};

const RenderUser: React.FC<RenderUserProps> = (props: RenderUserProps) => {

    const [t] = useTranslation();
    const ownerResource = useOwnerResource({ item: props.item });

    const _renderUsername = () => {

        const isDifferentUser = ownerResource.isDifferentUser();

        if(!isDifferentUser) return null;

        if (props.subtitle) {
            return (
                <div className="render-user-subtitle">
                    <span className="render-user-subtitle__label">{t('Belongs_to')}</span>
                    <span className="render-user-subtitle__name">{props.item.user_name}</span>
                </div>
            );
        }

        return (
            <div className="renderUser" style={{ margin: 0, fontSize: '13px', fontWeight: 500 }}>
                <span className="renderUser">
                    {t('Belongs_to')} <span className="pill ml-1">{props.item.user_name}</span>
                </span>
            </div>
        );

    }

    return(
        <>
            {_renderUsername()}
        </>
    );

};

export default React.memo(RenderUser);
